export const spaceBetweenSlides = 2;
